/* eslint-disable no-unused-vars */
import calculateTotalQuotaBloom from 'page/components/Simulator';
import { searchZero } from 'util/getAmount';
import { bankSimulator } from 'services/other/bankVision';
import { getGraceType } from 'types/graceType';
import { numberOfPeriods } from 'types/payFrecuency';
import { calculatePercentage } from 'util/percent';

const handleGraceType = (graceType) => {
  if (!graceType) {
    return 0;
  }
  const findGraceType = getGraceType.find((type) => type.id === graceType);
  return findGraceType;
};

export const handleSubmit = (
  form,
  setAmount,
  formProps,
  project,
  setDataSimulator,
  setShowMessage,
  setIsCalculating,
  handleScroll,
  withForm,
) => {
  const getTipoPago = numberOfPeriods[project?.frequency];
  const tipogracia = handleGraceType(project?.graceType);
  const amountInvested = String(form.amount).replaceAll(/\s|[.]/g, '');

  const handleTasaInteres = calculatePercentage(project?.ieaTax);

  setAmount(amountInvested);
  if (withForm) {
    formProps?.setValue('amount', searchZero(amountInvested));
  }

  if (project?.simulatorType === 'BULLET') {
    const data = calculateTotalQuotaBloom(
      project?.gracePeriod,
      project?.paymentPeriods,
      amountInvested,
      project?.ieaTax,
    );
    setDataSimulator({
      data: data.allQuotas,
      amountInteres: data.simulatorInfo.amountInteres,
      fixedFee: data.simulatorInfo.totalQuotaBloom,
      amountTotal: data.simulatorInfo.total,
      amountEarn: data.simulatorInfo.total - +amountInvested,
      lastQuota: data.simulatorInfo.lastQuota,
    });
    setShowMessage(true);
    handleScroll();
  } else {
    setIsCalculating(true);

    bankSimulator({
      monto: amountInvested,
      numeroPlazos: project?.paymentPeriods,
      periodosGarcia: String(project?.gracePeriod),
      tasaIteres: handleTasaInteres,
      tipoGracia: tipogracia.value,
      tipoPago: getTipoPago,
    })
      .then(({ data }) => {
        setIsCalculating(false);
        setShowMessage(true);
        const position = project?.gracePeriod;
        const amountTotal = data.reduce(
          (i, t) => i + (t.interescuota),
          parseFloat(form.amount),
        );
        const amountInteres = data.reduce((i, t) => i + +t.interescuota, 0);
        setDataSimulator({
          capital: data[position].capital,
          interes: data[position].interescuota,
          fixedFee:
            data[position].capital
            + data[position].interescuota
            - data[position].reteFuente,
          amountTotal,
          amountInteres,
          amountEarn: amountTotal - +amountInvested,
          data,
        });
        handleScroll();
      })
      .catch(() => {
        setIsCalculating(false);
      });
  }
};
